(() => {
  const root = document.querySelector('[data-mm-builder]');
  if (!root) return;

  const q = (s, r = root) => r.querySelector(s);
  const qa = (s, r = root) => Array.from(r.querySelectorAll(s));

  const linesEl = q('[data-mm-lines]');
  const counterEl = q('[data-mm-counter]');
  const subtotalEl = q('[data-mm-subtotal]');
  const subtotalLabelEl = q('[data-mm-subtotal-label]');
  const standardRow = q('[data-mm-standard-row]');
  const standardEl = q('[data-mm-standard]');
  const savingRow = q('[data-mm-saving-row]');
  const savingEl = q('[data-mm-saving]');
  const deliveryEl = q('[data-mm-delivery]');
  const deliveryLabelEl = q('[data-mm-delivery-label]');
  const grandEl = q('[data-mm-grand]');
  const noteEl = q('[data-mm-note]');
  const addBtn = q('[data-mm-builder-add]');
  const addLabel = q('[data-mm-add-label]');
  const statusEl = q('[data-mm-builder-status]');
  const errorEl = q('[data-mm-builder-error]');

  const defaultDiffuser = root.dataset.defaultDiffuser || '';
  const labelSubtotal = root.dataset.labelSubtotal || 'Sous-total';
  const labelOffer = root.dataset.labelOffer || "Prix de l'offre";
  const labelDelivery = root.dataset.labelDelivery || 'Livraison';
  const labelDeliveryEstimate = root.dataset.labelDeliveryEstimate || 'Livraison estimée';
  const freeLabel = root.dataset.freeLabel || 'Offerte';
  const feeCents = Number(root.dataset.feeCents) || 0;
  const freeCents = (Number(root.dataset.freeThreshold) || 0) * 1;
  const includedLabel = 'Inclus';

  const noteDefault = (noteEl && noteEl.dataset.noteDefault) || '';
  const notePack = (noteEl && noteEl.dataset.notePack) || noteDefault;

  const money = (cents) => {
    const fmt = (window.Shopify && window.Shopify.moneyFormat) || '{{amount_no_decimals}} DH';
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  };

  const tier = () => q('[data-mm-tier]:checked');
  const diffuser = () => q('[data-mm-diffuser]:checked');
  const rows = () => qa('[data-mm-dist]');
  const qtyOf = (row) => Number(q('[data-mm-qty]', row).textContent) || 0;
  const setQty = (row, n) => {
    q('[data-mm-qty]', row).textContent = String(n);
    row.classList.toggle('is-active', n > 0);
  };
  const chosen = () => rows().reduce((s, r) => s + qtyOf(r), 0);
  const wanted = () => {
    const t = tier();
    return t ? Number(t.dataset.refills) || 0 : 0;
  };

  // A tier is only offered if it points at a purchasable pack product.
  const pack = (t) => {
    if (!t || !t.dataset.packId) return null;
    const price = Number(t.dataset.packPrice);
    const compare = Number(t.dataset.packCompare) || 0;
    return {
      id: t.dataset.packId,
      title: t.dataset.packTitle || '',
      price,
      compare: compare > price ? compare : 0,
      soldOut: t.dataset.packSoldout === '1',
    };
  };

  function line(term, detail, pending) {
    const li = document.createElement('li');
    if (pending) li.className = 'is-pending';
    const a = document.createElement('span');
    a.className = 'mm-builder__line-name';
    a.textContent = term;
    const b = document.createElement('span');
    b.className = 'mm-builder__line-included';
    b.textContent = detail;
    li.appendChild(a);
    li.appendChild(b);
    return li;
  }

  const distribution = () =>
    rows()
      .filter((r) => qtyOf(r) > 0)
      .map((r) => ({ short: r.dataset.short, title: r.dataset.title, qty: qtyOf(r) }));

  const refillSummary = () => distribution().map((d) => `${d.qty} × ${d.short}`).join(' · ');

  // Moving 3 -> 2 refills trims from the end rather than clearing, so the
  // customer keeps the choices they already made.
  function clamp() {
    const want = wanted();
    let have = chosen();
    if (have <= want) return;
    for (const row of rows().slice().reverse()) {
      while (have > want && qtyOf(row) > 0) {
        setQty(row, qtyOf(row) - 1);
        have -= 1;
      }
      if (have <= want) break;
    }
  }

  function update() {
    const t = tier();
    const p = pack(t);
    const d = diffuser();
    const want = wanted();
    const have = chosen();

    rows().forEach((row) => {
      q('[data-mm-inc]', row).disabled = have >= want || row.hasAttribute('data-soldout');
      q('[data-mm-dec]', row).disabled = qtyOf(row) <= 0;
    });

    if (counterEl) {
      counterEl.textContent = `${have} sur ${want} recharge${want > 1 ? 's' : ''} sélectionnée${have > 1 ? 's' : ''}`;
      counterEl.classList.toggle('is-complete', want > 0 && have === want);
    }

    linesEl.innerHTML = '';
    linesEl.appendChild(
      d ? line(`Diffuseur : ${d.dataset.title}`, includedLabel, false) : line('Diffuseur', '—', true)
    );
    const refills = refillSummary();
    linesEl.appendChild(
      refills ? line(`Recharges : ${refills}`, includedLabel, false) : line('Recharges', '—', true)
    );

    const standard = p ? p.compare : 0;
    const total = p ? p.price : 0;
    const saving = standard > total ? standard - total : 0;

    const free = total > 0 && total >= freeCents;
    const deliveryCents = free ? 0 : feeCents;

    if (deliveryLabelEl) deliveryLabelEl.textContent = free ? labelDelivery : labelDeliveryEstimate;
    if (deliveryEl) deliveryEl.textContent = p ? (free ? freeLabel : money(deliveryCents)) : '—';
    if (grandEl) grandEl.textContent = p ? money(total + deliveryCents) : '—';

    subtotalEl.textContent = p ? money(total) : '—';
    if (subtotalLabelEl) subtotalLabelEl.textContent = saving > 0 ? labelOffer : labelSubtotal;
    if (standardRow) {
      standardRow.hidden = saving <= 0;
      if (standardEl) standardEl.textContent = money(standard);
    }
    if (savingRow) {
      savingRow.hidden = saving <= 0;
      if (savingEl) savingEl.textContent = money(saving);
    }
    if (noteEl) noteEl.textContent = p ? notePack : noteDefault;

    const complete = Boolean(p) && !p.soldOut && Boolean(d) && want > 0 && have === want;
    addBtn.disabled = !complete;
    if (addLabel && complete) addLabel.textContent = `Commander — ${money(total + deliveryCents)}`;

    qa('[data-mm-dot-step]').forEach((dot) => {
      const step = Number(dot.dataset.mmDotStep);
      dot.classList.remove('is-active', 'is-done');
      if (step === 1 && t) dot.classList.add('is-done');
      if (step === 2 && d) dot.classList.add('is-done');
      if (step === 3 && complete) dot.classList.add('is-done');
    });
    const activeStep = !t ? 1 : !d ? 2 : 3;
    const activeDot = q(`[data-mm-dot-step="${activeStep}"]`);
    if (activeDot) activeDot.classList.add('is-active');

    statusEl.textContent = complete
      ? ''
      : !d
        ? 'Choisissez un diffuseur pour continuer.'
        : have < want
          ? `Il reste ${want - have} recharge${want - have > 1 ? 's' : ''} à choisir.`
          : '';
  }

  // The composer hands its finished selection to the order modal rather than
  // pushing the customer through the cart. Nothing is added here: the modal
  // owns the single write to the cart, so a customer who edits their choice
  // there cannot end up with two packs.
  function handOff() {
    if (addBtn.disabled) return;
    const t = tier();
    const p = pack(t);
    const d = diffuser();
    if (!p || !d) return;

    if (!window.MMOrderModal) {
      errorEl.textContent = 'Commande indisponible pour le moment. Rechargez la page.';
      errorEl.hidden = false;
      return;
    }
    errorEl.hidden = true;
    window.MMOrderModal.open({
      pack: p.id,
      diffuser: d.value,
      refills: distribution()
        .map((x) => `${x.short}:${x.qty}`)
        .join(','),
    });
  }

  qa('[data-mm-tier]').forEach((i) =>
    i.addEventListener('change', () => {
      clamp();
      update();
    })
  );
  qa('[data-mm-diffuser]').forEach((i) => i.addEventListener('change', update));
  rows().forEach((row) => {
    q('[data-mm-inc]', row).addEventListener('click', () => {
      if (chosen() >= wanted()) return;
      setQty(row, qtyOf(row) + 1);
      update();
    });
    q('[data-mm-dec]', row).addEventListener('click', () => {
      if (qtyOf(row) <= 0) return;
      setQty(row, qtyOf(row) - 1);
      update();
    });
  });
  addBtn.addEventListener('click', handOff);

  // Withdraw any tier with no purchasable pack behind it rather than letting it
  // fall back to adding components separately at full price.
  qa('[data-mm-tier]').forEach((input) => {
    const p = pack(input);
    if (!p || p.soldOut) input.disabled = true;
    const wrap = input.closest('.mm-builder__tier');
    if (wrap) wrap.classList.toggle('is-unavailable', input.disabled);
  });
  if (!tier() || tier().disabled) {
    const first = q('[data-mm-tier]:not([disabled])');
    if (first) first.checked = true;
  }

  const wantedTier = new URLSearchParams(window.location.search).get('offre');
  if (wantedTier) {
    const match = q(`[data-mm-tier][value="${CSS.escape(wantedTier)}"]`);
    if (match && !match.disabled) match.checked = true;
  }

  if (!diffuser() && defaultDiffuser) {
    const d = q(`[data-mm-diffuser][data-handle="${CSS.escape(defaultDiffuser)}"]`);
    if (d && !d.disabled) d.checked = true;
  }

  clamp();
  update();
})();
